module.exports = __webpack_public_path__ + "img/2.f114f67e.jpg";